import dayjs from "dayjs";

export const isDateWithinLastWeek = (date?: number) =>
  dayjs(date).startOf("day").isAfter(dayjs().startOf("day").subtract(7, "day"));
